// The Comic Machine - Comic

var Comic = (function() {

  // A Comic object to be managed by the Comic Manager
  function Comic(options) {

    options = options || {};

    // Set the Comic meta
    this.series = options.series || null;
    this.title = options.title || "";
    this.volume = options.volume || 0;
    this.issue = options.issue || 0;
    this.author = options.author || null;
    this.id = options.id || null;
    this.uid = options.uid || null;
    this.user = options.user || null;
    this.date = options.date || new Date();
    this.version = options.version || 1;
    this.published = options.published || false;
    this.access = options.access || "";

    // Set the page list
    this.pageList = options.pages || [];
    // Set the intiial pages if none specified
    if (this.pageList.length <= 0) {
      // Create the cover page
      this.pageList.push(new Page({
        comic: this
      }));
      // Create the first page
      this.pageList.push(new Page({
        comic: this
      }));
    }

    // Set the current page index
    this.pageIndex = options.index || 0;

  }

  // Placeholder for current comic reference
  Comic.current = null;

  // Global events
  Comic.events = new Events();

  // Creates a new comic instance
  Comic.create = function() {

    // HACK: Get the title and series via user input
    var title = window.prompt("Comic Title:");

    if (!title) return;

    // Create new comic instance
    Comic.current = new Comic({
      title: title
    });

    // Get the JSON export
    var data = Comic.current.exportJSON();

    // Create the comic on the server via the API
    API.comics.create(data, function(success, response) {
      if (success) {
        // Add user and comic uid to the current data
        Comic.current.uid = response.uid;
        Comic.current.user = response.user;
        // Route to the creator page
        Events.global.emit("tcm.route", "/creator/comic/" + response.uid);
        // Render the current page of the new comic
        Comic.renderPage();
        // Fire event to reset comic
        Events.global.emit("tcm.comic.reset");
      }
    });

  };

  // Loads a previously saved comic
  Comic.load = function(data, callback) {

    var pageCount = 0;
    var layerCount = 0;

    // Create new comic with saved data
    var comic = new Comic({
      title: data.title,
      series: data.series,
      issue: data.issue,
      volume: data.volume,
      author: data.author,
      id: data.id,
      uid: data.uid,
      user: data.user,
      date: new Date(data.date),
      version: data.version,
      published: data.published,
      access: window.atob(data.access),
    });

    // Reset the page list
    comic.pageList = [];

    // Method to handle pages
    function handlePage(content, i, callback) {

      // TODO: Update for production paths
      // TODO: Script the change in the database once ready
      var thumbnail = !content.thumbnail ? null : content.thumbnail.replace(
        "api-stage.thecomicmachine.com:8090/assets",
        "assets.stage.thecomicmachine.com"
      );
      thumbnail = !thumbnail ? null : thumbnail.replace(
        "api.stage.thecomicmachine.com/assets",
        "assets.stage.thecomicmachine.com"
      );

      // Create a new page with the saved data
      var page = new Page({
        comic: comic,
        index: content.index,
        uid: content.uid,
        id: content.id,
        name: content.name,
        thumbnail: thumbnail ? {
          url: thumbnail
        } : null,
      });

      // Add the new page to the comic
      comic.addPage(page, null, true);
      // Reset the page layer list
      page.pageLayers = [];

      // Reset layer count
      layerCount = 0;

      // Loop over page layers to create new instances
      handleLayer(page, content, content.layers[0], 0, function() {

        // Fire the page update event
        // Events.global.emit("tcm.page.update");

        pageCount += 1;

        if (pageCount >= data.pages.length) {
          callback && callback();
        } else {
          handlePage(data.pages[pageCount], pageCount, callback);
        }

      });

    }

    // Method to handle layers
    function handleLayer(page, item, content, i, callback) {

      var options = {
        page: page,
        uid: content.uid,
        name: content.name,
        type: content.type,
        action: content.action,
        delay: content.delay,
        duration: content.duration,
        scale: content.scale,
        transition: content.transition,
        loop: content.loop,
        reverse: content.reverse,
        original: content.original,
        edits: content.edits,
        removeAfter: content.removeAfter
      };

      // Set the layer size, if present
      if (content.size) {
        options.width = content.size.width;
        options.height = content.size.height;
      }

      // Set the layer position, if present
      if (content.position) {
        options.x = content.position.x;
        options.y = content.position.y;
      }

      // Set the layer size / position based on end state, if present
      if (content.transition && content.transition.end) {
        options.preview = "end";
        if (content.transition.end.width || content.transition.end.width === 0) {
          options.width = content.transition.end.width;
        }
        if (content.transition.end.height || content.transition.end.height === 0) {
          options.height = content.transition.end.height;
        }
        if (content.transition.end.x || content.transition.end.x === 0) {
          options.x = content.transition.end.x;
        }
        if (content.transition.end.y || content.transition.end.y === 0) {
          options.y = content.transition.end.y;
        }
      }

      // Create a new layer with the save data
      var layer = new Layer(options);
      var layerOptions = {
        deselect: true
      };

      // Set initial proportion lock state
      layer.proportionLock = content.proportionLock === false ? false : true;

      // Method to fire callback when appropriate
      function checkCallback() {
        layerCount += 1;
        if (layerCount >= item.layers.length) {
          callback && callback();
        } else {
          handleLayer(page, item, item.layers[layerCount], layerCount, callback)
        }
      }

      // Check for associated text
      if (content.text && content.text.value) {
        content.text.layer = layer.canvas.layer;
        content.text = new TextElement(content.text);
        content.text.updateCanvas();
        content.text.generateImage(function(image, data) {
          // Add text to layer
          layer.text = content.text;
          layer.content = layer.text.generateStaticCanvas();
          layer.asset = {
            image: image,
            data: data
          };
          // Add the new layer to the page
          page.addLayer(layer, i, layerOptions);
          // Fire the callback, if present
          checkCallback();
        });
        // Check for associated asset
      } else if (content.asset && content.asset !== "text") {
        // TODO: Update for production paths
        // TODO: Script the change in the database once ready
        var assetUrl = content.asset.replace(
          "api-stage.thecomicmachine.com:8090/assets",
          "assets.stage.thecomicmachine.com"
        );
        assetUrl = assetUrl.replace(
          "api.stage.thecomicmachine.com/assets",
          "assets.stage.thecomicmachine.com"
        );
        // Load the asset
        Asset.load(assetUrl, null, function(asset, image) {
          // Set the image asset
          layer.asset = asset;
          if (image) {
            // Set the image content
            layer.content = image;
            // Draw the image on the canvas
            layer.canvas.drawImage(image, null, {
              x: layer.size.width,
              y: layer.size.height,
            });
          }
          // Set the initial thumbnail
          layer.updateThumbnail();
          // Add the new layer to the page
          page.addLayer(layer, i, layerOptions);
          // Render the current page of the new comic
          // page.renderPage();
          // Update the layer UI
          // Events.global.emit("tcm.layer.update");
          // Fire the callback, if present
          checkCallback();
        });
      } else {
        // Add the new layer to the page
        page.addLayer(layer, i, layerOptions);
        // Fire the callback, if present
        checkCallback();
      }

    }

    // Loop over pages to create new instances
    handlePage(data.pages[0], 0, function() {

      // Set the initial page index
      comic.pageIndex = 0;
      // Create new comic instance
      Comic.current = comic;
      // Render the current page of the new comic
      Comic.current.renderPage();

      // Update the layer and page UI
      Events.global.emit("tcm.layer.update");
      Events.global.emit("tcm.page.update");
      // Fire event to reset comic
      Events.global.emit("tcm.comic.reset");

      document.querySelector(".loading").setAttribute("data-active", "false");

      window.setTimeout(function() { // HACK
        LayerController.updateDOM();
        callback && callback();
      }, 0);

      // Log the result
      console.log("Comic.load", comic);

    });

  };

  // Create the display name dynamically
  Object.defineProperty(Comic.prototype, "name", {
    get: function() {
      return [
        // The name of the series followed by a spaced dash, if present
        (this.series ? this.series + " - " : ""),
        // The name of the issue or Untitled
        (this.title ? this.title : ""),
        // Opening parentheses, if there is a volume or issue
        (this.issue || this.volume ? " (" : ""),
        // The issue number, if present
        (this.issue ? "Issue #" + this.issue : ""),
        // Comma and space delimiter, if both volume and issue are present
        (this.issue && this.volume ? ", " : ""),
        // The volume number, if present
        (this.volume ? "Volume #" + this.volume : ""),
        // Closing parentheses, if there is a volume or issue
        (this.issue || this.volume ? ")" : "")
      ].join("");
    }
  });

  // Method to get current page
  Comic.prototype.currentPage = function() {
    return this.pageList[this.pageIndex];
  };
  // Shorthand method to get the current page
  Comic.currentPage = function() {
    return Comic.current ? Comic.current.currentPage() : null;
  };

  // Method to select a page
  Comic.prototype.selectPage = function(index) {
    return Page.selectPage(this, index);
  };
  // Shorthand method to select a page
  Comic.selectPage = function(index) {
    return Comic.current.selectPage(index);
  };

  // Method to add a new page
  Comic.prototype.addPage = function(page, index, deselect) {
    return Page.addPage(this, page, index, deselect);
  };
  // Shorthand method to add a new page
  Comic.addPage = function(page, index, deselect) {
    return Comic.current.addPage(page, index, deselect);
  };

  // Method to remove a page
  Comic.prototype.removePage = function(index) {
    Page.removePage(this, index);
  };
  // Shorthand method to remove a page
  Comic.removePage = function(index) {
    Comic.current.removePage(index);
  };

  // Method to get current layer
  Comic.prototype.currentLayer = function() {
    var page = this.currentPage();
    return page ? page.currentLayer() : null;
  };
  // Shorthand method to get current layer
  Comic.currentLayer = function() {
    return Comic.current ? Comic.current.currentLayer() : null;
  };

  // Method to select current layer
  Comic.prototype.selectLayer = function(index) {
    return this.currentPage().selectLayer(index);
  };
  // Shorthand method to select current layer
  Comic.selectLayer = function(index) {
    return Comic.current.selectLayer(index);
  };

  // Method to render the current page of the comic
  Comic.prototype.renderPage = function() {
    this.currentPage().renderPage();
  };
  // Shorthand method to select a page
  Comic.renderPage = function() {
    Comic.current && Comic.current.renderPage();
  };

  // Method to save comic as JSON
  Comic.prototype.exportJSON = function(page, preview) {

    var pages = page || page === 0 ? [this.pageList[page]] : this.pageList;

    var data = {
      uid: this.uid,
      user: this.user,
      title: this.title,
      series: this.series,
      name: this.name,
      issue: this.issue,
      volume: this.volume,
      author: this.author,
      id: this.id,
      date: this.date,
      version: this.version,
      published: this.published,
      pages: [],
      access: window.btoa(this.access),
    };

    // Loop over pages to add data
    pages.forEach(function(page) {

      var thumbnail = page.thumbnail;

      var content = {
        uid: page.uid,
        id: page.id,
        index: page.index,
        name: page.name,
        thumbnail: thumbnail && thumbnail.url ? thumbnail.url : null,
        layers: [],
      };

      // Loop over page layers to add data
      page.pageLayers.forEach(function(layer) {
        var asset = layer.asset && layer.asset.uid ? layer.asset.uid : null;
        var text = null;
        if (layer.text && layer.text.value) {
          var data = layer.canvas.element.toDataURL("image/png");
          asset = preview === true ? data : "text";
          text = layer.text.generateExport();
        }
        var transition = clone(layer.transition);
        if (transition.start) {
          delete transition.start.set;
        }
        if (transition.end) {
          delete transition.end.set;
        }
        content.layers.push({
          uid: layer.uid,
          name: layer.name,
          type: layer.type,
          asset: asset,
          text: text,
          action: layer.action,
          delay: layer.delay,
          duration: layer.duration,
          position: layer.position,
          size: layer.size,
          scale: layer.scale,
          loop: layer.loop,
          reverse: layer.reverse,
          transition: transition,
          original: layer.original,
          edits: layer.edits,
          proportionLock: layer.proportionLock,
          removeAfter: layer.removeAfter,
        });
      });

      data.pages.push(content);

    });

    return data;

  };

  // Public / exposed class
  return Comic;

})();
